export default "data:image/webp;base64,UklGRiYAAABXRUJQVlA4TBoAAAAvJ8AFABALJvnDxbZTIJDk7zjL0f8MX/E9Hw=="